/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import './index.css'
import { DesktopNavbar } from '../NavBar/Desktop/DesktopNavbar'
import {useState, useEffect, useRef} from 'react'
import "react-datepicker/dist/react-datepicker.css";
import beef from '../../assets/beef.svg'
import makanan1 from '../../assets/makanan1.png'
import calendar from '../../assets/calendar-1.svg'
import { useNavigate } from "react-router-dom";
import pork from '../../assets/pork.svg'
import time from '../../assets/time2.svg'
import stove from '../../assets/stove.svg'
import microwave from '../../assets/microwave.svg'
import circleback from '../../assets/circleback.svg'
import oven from '../../assets/oven.svg'
import location from '../../assets/pin-1.svg'
import foto1 from '../../assets/foto4.png'
import { CSSTransition } from 'react-transition-group';
import spinner from '../../assets/spinner.gif'

export const PageSubmitBooking = () => {

    const [detail, setDetail] = useState()
    const [loading, setLoading] = useState(true)
    const [total, setTotal] = useState()
    const firstUpdate = useRef(true)
    const [showNavPopup, setShowNavPopup] = useState(false)

    const handleCloseAll = () => {
        setShowNavPopup(false)
    }
    useEffect(() =>{
        window.scrollTo(0, 0)
        setLoading(true)
        setDetail({nama:"Fauzan Pradana", foto:foto1,Type:"Asian",Menu:["Beef bulgogi", "Yaki gyoza"],bahan:["cow","pork"],alat:['Oven','Microwave','Stove'],fotoMakanan:makanan1,tanggal:localStorage.getItem("tanggal"), jam:localStorage.getItem("jam"),style:localStorage.getItem('style'),specialRequest:localStorage.getItem('specialRequest'),pax:localStorage.getItem('pax'), total:localStorage.getItem('total'),address:localStorage.getItem('address')})
        localStorage.setItem('nav', 'fnd')
    },[])

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
        }else{
            setLoading(false)
            setTotal(parseInt(detail.total))
        }
    },[detail])

    const [voucher, setVoucher] = useState('') 
    const [standby, setstandby] = useState(true)
    ;
    const history = useNavigate()

    const convertToRupiah = (angka) => {
        var rupiah = '';		
        var angkarev = angka.toString().split('').reverse().join('');
        for(var i = 0; i < angkarev.length; i++) if(i%3 === 0) rupiah += angkarev.substr(i,3)+'.';
        return rupiah.split('',rupiah.length-1).reverse().join('');
    }

    useEffect(()=>{
        
        if(standby===false){
            setTimeout(function() {
                localStorage.setItem('totalAfter',total)
                history('/category/chefList/detailChef/detailMenu/setSchedule/setVenue/submitBooking/Review')
           }, 500);
        }
    },[standby])

    
    
    return (
        <div onClick={e => {e.stopPropagation();handleCloseAll()}} id="maincontainer" style={{minWidth:"100%", minHeight:"100vh", backgroundColor:"#111111", position:"relative", overflow:"unset"}}>
            <DesktopNavbar showPopup={showNavPopup} setShowPopup={setShowNavPopup}></DesktopNavbar>
            <img onClick={() => history(-1)} className='backmobile' alt="back" src={circleback}></img>
            {
                loading?
                <img alt='loading' className='taplakLoading' src={spinner}></img>
                :
                <CSSTransition in={standby} timeout={{appear:1000,enter:2000,exit:1000}} mountOnEnter={true} appear={true} classNames="SBPtrans">
                <div className='SBPkontainer'>
                    <p className='big bold white SBPtittle'>Submit Booking</p>
                    <div className='SBPkonten flex'>
                        <div className='SBPkontainerkiri'>
                            <p className='medium white'>Your booking details</p>
                            <p className='white tiny SBPmargin'>Chef</p>
                            <div className='flex SBPmargin2'>
                                <div className='SBPimage' style={{backgroundImage:`url(${detail.foto})`}}></div>
                                <p className='white small'>{detail.nama}</p>
                            </div>
                            <div className='SBPline SBPmargin'></div>
                            <p className='white tiny SBPmargin'>Menu</p>
                            <div className='flex SBPmargin2'>
                                <div className='SBPimage' style={{backgroundImage:`url(${detail.fotoMakanan})`}}></div>
                                <div>
                                    <p className='white small'>{detail.Type} Food</p>
                                    <p className='white tiny bold SBPmargin3'>{
                                        detail.Menu.map((post) => {
                                            if(post===detail.Menu[0]){
                                                return(
                                                    <span>{post}</span>
                                                )
                                            }else{
                                                return(
                                                    <span>, {post}</span>
                                                )
                                            }
                                        })
                                    }</p>
                                    <div className='flex SBPmargin3'>
                                        {
                                            detail.bahan.map((post) => {
                                                if(post === 'pork'){
                                                    return(
                                                        <img alt="icon" className='SBPicon' src={pork}></img>
                                                    )
                                                }if(post === 'cow'){
                                                    return(
                                                        <img alt="icon" className='SBPicon' src={beef}></img>
                                                    )
                                                }
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='SBPline SBPmargin'></div>
                            <p className='white tiny SBPmargin'>Tools Needed</p>
                            <div className='flex SBPmargin2'>
                                {
                                    detail.alat.map((post) => {
                                        if(post === "Oven"){
                                            return(
                                                <div className='SBPtools'>
                                                    <img alt="icon" className='SBPicon2' src={oven}></img>
                                                    <p className='white tiny'>Oven</p>
                                                </div>
                                            )
                                        }if(post === "Microwave"){
                                            return(
                                                <div className='SBPtools'>
                                                    <img alt="icon" className='SBPicon2' src={microwave}></img>
                                                    <p className='white tiny'>Microwave</p>
                                                </div>
                                            )
                                        }if(post === "Stove"){
                                            return(
                                                <div className='SBPtools'>
                                                    <img alt="icon" className='SBPicon2' src={stove}></img>
                                                    <p className='white tiny'>Stove</p>
                                                </div>
                                            )
                                        }
                                    })
                                }
                            </div>
                            <div className='SBPline SBPmargin'></div>
                            <div className='SBPmargin flex' style={{alignItems:"center"}}>
                                <img alt="icon" className='SBPicon' src={calendar}></img>
                                <p className='tiny white' style={{marginRight:"32px"}}>{detail.tanggal}</p>
                                <img alt="icon" className='SBPicon' src={time}></img>
                                <p className='tiny white' >{detail.jam}</p>
                            </div>
                            <div className='SBPmargin flex' style={{alignItems:"center"}}>
                                <img alt="icon" className='SBPicon' src={location}></img>
                                <p className='tiny white' >{detail.address}</p>
                            </div>
                            <div className='SBPline SBPmargin'></div>
                            <p className='SBPmargin tiny white'>Serving style: <span className='bold'>{detail.style}</span></p>
                            <div className='SBPline SBPmargin'></div>
                            <p className='SBPmargin tiny white'>Special Request</p>
                            <p className='SBPmargin2 tiny white bold'>{detail.specialRequest}</p>
                        </div>

                        <div className='SBPkontainerkanan'>
                            <div className='SBPkontenputih'>
                                <p className='bold medium'>Invoice Preview</p>
                                <div className='SBPmargin4 flex'>
                                    <p className='small'>{detail.pax} pax</p>
                                    <p className='small' style={{marginLeft:"auto"}}>IDR {convertToRupiah(detail.total)}</p>
                                </div>
                                <div className='SBPline SBPmargin'></div>
                                <div className='SBPmargin flex'>
                                    <p className='small'>Service Fee</p>
                                    <p className='small' style={{marginLeft:"auto"}}>-</p>
                                </div>
                                <div className='SBPline SBPmargin'></div>
                                <p className='small SBPmargin'>Voucher Code</p>
                                <div className='SBPmargin2 flex'>
                                    <input type='text' value={voucher} onChange={e => setVoucher(e.target.value)} placeholder='Enter voucher code' className='SBPform'></input>
                                    <button className='SBPbutton tiny bold'>Apply</button>
                                </div>
                                <div className='SBPline SBPmargin'></div>
                                <div className='SBPmargin flex'>
                                    <p className='small'>Voucher Ammount</p>
                                    <p className='small' style={{marginLeft:"auto"}}>-</p>
                                </div>
                                <div className='SBPmargin4 flex'>
                                    <p className='medium bold'>Total</p>
                                    <p className='medium bold' style={{marginLeft:"auto"}}>IDR {convertToRupiah(total)}</p>
                                </div>
                            </div>

                            <div className='SBPkontenputih SBPmargin4'>
                                <p className='bold medium'>Submit Your Booking</p>
                                <p className='SBPmargin2 small'>After submitting your order we will review it first</p>
                                <button onClick={() => setstandby(false)} className='SBPbutton2 small bold SBPmargin4'>Continue to Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
                </CSSTransition>
            }
        </div>
    )
  }